<template>
  <div class="page donation-page">
    <h2 class="page-title">爱心捐赠管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="关键词"><el-input v-model="query.keyword" placeholder="姓名/昵称/电话" clearable /></el-form-item>
          </el-col>
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="输入泉井名称" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="捐赠方向">
              <el-select v-model="query.direction" clearable placeholder="全部">
                <el-option label="认领水质检测费用" :value="1" />
                <el-option label="支持巡护维护费用" :value="2" />
                <el-option label="认领修缮改造费用" :value="3" />
                <el-option label="支持地图开发运营" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="公示状态">
              <el-select v-model="query.auditStatus" clearable placeholder="全部">
                <el-option label="待审核" :value="0" />
                <el-option label="通过公示" :value="1" />
                <el-option label="已拒绝" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="提交时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <span class="table-total">共 {{ total }} 条</span>
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="用户" min-width="160">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="36" :src="scope.row.avatarUrl" icon="el-icon-user-solid" />
              <div>
                <div class="user-name">{{ scope.row.nickname || scope.row.donorName || '-' }}</div>
                <div class="user-sub">{{ scope.row.phone }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="wellName" label="泉井名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="捐赠方向" min-width="180">
          <template slot-scope="scope">{{ directionText(scope.row.direction) }}</template>
        </el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="100" />
        <el-table-column prop="donorName" label="姓名" width="110" />
        <el-table-column prop="phone" label="联系电话" width="140" />
        <el-table-column prop="message" label="留言" min-width="180" show-overflow-tooltip />
        <el-table-column label="提交时间" width="160">
          <template slot-scope="scope">{{ formatDate(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="公示状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="donationTagType(scope.row.auditStatus)">{{ donationStatusText(scope.row.auditStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text view" @click="handleView(scope.row)">查看</span>
              <span class="action-text audit" :class="{ disabled: scope.row.auditStatus === 1 }" @click="scope.row.auditStatus !== 1 && auditDonate(scope.row, 1)">通过公示</span>
              <span class="action-text reject" :class="{ disabled: scope.row.auditStatus === 2 }" @click="scope.row.auditStatus !== 2 && auditDonate(scope.row, 2)">拒绝</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <!-- 详情弹框 -->
    <el-dialog title="捐赠详情" :visible.sync="detailVisible" width="600px">
      <el-descriptions v-if="currentRow" :column="2" border size="small">
        <el-descriptions-item label="捐赠人昵称">{{ currentRow.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ currentRow.donorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentRow.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="泉井名称">{{ currentRow.wellName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="捐赠方向" :span="2">{{ directionText(currentRow.direction) }}</el-descriptions-item>
        <el-descriptions-item label="金额(元)">{{ currentRow.amount }}</el-descriptions-item>
        <el-descriptions-item label="公示状态"><el-tag :type="donationTagType(currentRow.auditStatus)">{{ donationStatusText(currentRow.auditStatus) }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="提交时间">{{ formatDate(currentRow.createdAt) }}</el-descriptions-item>
        <el-descriptions-item label="留言" :span="2">{{ currentRow.message || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchDonations, auditDonation, deleteDonation } from '@/api'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { pageNum: 1, pageSize: 10, keyword: '', wellName: '', direction: undefined, auditStatus: undefined },
      detailVisible: false,
      currentRow: null
    }
  },
  watch: {
    'query.keyword'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) },
    'query.wellName'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) }
  },

  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchDonations(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, keyword: '', wellName: '', direction: undefined, auditStatus: undefined }
      this.loadData()
    },
    handleView(row) { this.currentRow = row; this.detailVisible = true },
    async auditDonate(row, status) {
      const action = status === 1 ? '通过公示' : '拒绝'
      try {
        await this.$confirm(`确认${action}该捐赠记录吗？`, '操作确认', { type: 'warning' })
        await auditDonation({ id: row.id, status, remark: status === 1 ? '审核通过公示' : '捐赠信息不符合公示要求' })
        this.$message.success(`捐赠已${action}`)
        this.loadData()
      } catch (e) {}
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该捐赠记录吗？删除后不可恢复。', '删除确认', { type: 'warning' })
        await deleteDonation(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const headers = ['ID', '昵称', '真实姓名', '联系电话', '泉井名称', '捐赠方向', '金额(元)', '留言', '提交时间', '公示状态']
      const rows = this.tableData.map(r => [r.id, r.nickname, r.donorName, r.phone, r.wellName, this.directionText(r.direction), r.amount, r.message, this.formatDate(r.createdAt), this.donationStatusText(r.auditStatus)])
      const csv = [headers, ...rows].map(items => items.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `爱心捐赠_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    directionText(v) {
      return { 1: '认领一年水质检测费用', 2: '支持一年巡护维护费用', 3: '认领修缮改造费用', 4: '支持地图开发运营' }[v] || '其他'
    },
    donationStatusText(v) { return v === 1 ? '通过公示' : v === 2 ? '已拒绝' : '待审核' },
    donationTagType(v) { return v === 1 ? 'success' : v === 2 ? 'danger' : 'warning' },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 16) : '-' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-select,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.table-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.table-total { font-size: 13px; color: #606266; }
.user-cell { display: flex; align-items: center; gap: 8px; }
.user-name { font-weight: 600; font-size: 13px; color: #303133; }
.user-sub { font-size: 12px; color: #909399; }
.action-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.audit { color: #2f8f5b; }
.action-text.reject { color: #e6a23c; }
.action-text.delete { color: #f56c6c; }
.action-text.disabled { color: #c0c4cc; cursor: not-allowed; }
.action-text.disabled:hover { text-decoration: none; }
</style>
